import { useEffect, useRef } from "react";

function SelectedProjects() {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            // observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="section projects">
      <div className="container-fluid">

        {/* Section Title */}
        <div className="mb-5 section-title">
          <h1>Selected Projects</h1>
        </div>

        <div className="row">

          {/* Project 1 */}
          <div className="col-12 col-lg-6 mb-5">
            <div
              className="project-card"
              ref={(el) => (cardsRef.current[0] = el)}
            >
              <h3>Political Response Clarity Classification using NLP</h3>

              <div className="project-par">
                <p>
                  <strong>Problem:</strong> Political interviews often contain ambiguous
                  or evasive responses, making it difficult to objectively assess
                  transparency.
                </p>
                <p>
                  <strong>Action:</strong> Fine-tuned transformer-based models on
                  long-form interview data and explored hierarchical classification to
                  detect clarity and linguistic evasion.
                </p>
                <p>
                  <strong>Result:</strong> Built an automated system that reliably
                  classifies responses as clear or evasive, enabling quantitative
                  analysis of political discourse.
                </p>
              </div>

              <a href="#">View details →</a>
            </div>
          </div>

          {/* Project 2 */}
          <div className="col-12 col-lg-6 mb-5">
            <div
              className="project-card"
              ref={(el) => (cardsRef.current[1] = el)}
            >
              <h3>Advancing Human Motion Analysis with LLMs and VLMs</h3>

              <div className="project-par">
                <p>
                  <strong>Problem:</strong> Traditional motion models struggle with
                  semantic understanding and long-term temporal dependencies required
                  for realistic motion analysis.
                </p>
                <p>
                  <strong>Action:</strong> Investigated Large Language Models and
                  Vision-Language Models for motion prediction, generation, and
                  denoising by leveraging their sequence reasoning capabilities.
                </p>
                <p>
                  <strong>Result:</strong> Demonstrated that generative AI architectures
                  can be adapted beyond text to enable semantically-aware motion
                  synthesis.
                </p>
              </div>

              <a href="#">View details →</a>
            </div>
          </div>

          {/* Project 3 */}
          <div className="col-12 col-lg-6 mb-5">
            <div
              className="project-card"
              ref={(el) => (cardsRef.current[2] = el)}
            >
              <h3>IoT-Based Indoor Air Quality Monitoring System</h3>

              <div className="project-par">
                <p>
                  <strong>Problem:</strong> Indoor air pollutants are invisible and
                  difficult to monitor in real time, posing health risks to occupants.
                </p>
                <p>
                  <strong>Action:</strong> Designed an end-to-end IoT system using ESP32
                  sensors, MQTT-based cloud pipelines, and real-time analytics with
                  visualization dashboards.
                </p>
                <p>
                  <strong>Result:</strong> Delivered a scalable monitoring solution that
                  provides immediate alerts and long-term insights into environmental
                  health.
                </p>
              </div>

              <a href="#">View details →</a>
            </div>
          </div>

          {/* Project 4 */}
          <div className="col-12 col-lg-6 mb-5">
            <div
              className="project-card"
              ref={(el) => (cardsRef.current[3] = el)}
            >
              <h3>Operating Systems: Dynamic Paging Memory Simulator</h3>

              <div className="project-par">
                <p>
                  <strong>Problem:</strong> Memory management concepts such as paging
                  and fragmentation are difficult to visualize in multi-process
                  operating systems.
                </p>
                <p>
                  <strong>Action:</strong> Implemented a C-based simulator with process
                  control blocks, page tables, logical-to-physical address mapping, and
                  fragmentation analysis.
                </p>
                <p>
                  <strong>Result:</strong> Created an educational tool that clearly
                  demonstrates OS-level memory allocation behavior and efficiency.
                </p>
              </div>

              <a href="#">View details →</a>
            </div>
          </div>

          {/* Project 5 */}
          <div className="col-12 col-lg-6 mb-5">
            <div
              className="project-card"
              ref={(el) => (cardsRef.current[4] = el)}
            >
              <h3>Bioinformatics Analysis of HLA-C in Stomach Cancer</h3>

              <div className="project-par">
                <p>
                  <strong>Problem:</strong> Certain stomach cancers evade immune
                  detection by mutating the HLA-C protein, weakening immune response.
                </p>
                <p>
                  <strong>Action:</strong> Analyzed genomic datasets and applied
                  protein–protein interaction mapping with 3D structural modeling to
                  identify mutation hotspots.
                </p>
                <p>
                  <strong>Result:</strong> Identified a critical mutation site disrupting
                  molecular interactions, offering insight into immune evasion
                  mechanisms and potential therapeutic targets.
                </p>
              </div>

              <a href="#">View details →</a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default SelectedProjects;
